import apiClient from "./apiClient"; // Імпортуємо твій новий клієнт з цієї ж папки

// Додаємо заголовок для обходу попереджень тунелю (якщо використовуєш localtunnel/ngrok)
apiClient.interceptors.request.use((config) => {
  config.headers["bypass-tunnel-reminder"] = "true";
  return config;
});

/**
 * Уніфікована функція для виконання POST-запитів через apiClient з логікою повторних спроб.
 */
const apiPost = async (endpoint, data = {}, retries = 3, delay = 1000) => {
  for (let attempt = 0; attempt < retries; attempt++) {
    try {
      const response = await apiClient.post(endpoint, data);
      return response.data;
    } catch (error) {
      if (!error.response) {
        console.error(
          `Помилка з'єднання ${endpoint}, спроба ${attempt + 1}:`,
          error,
        );

        if (attempt === retries - 1) {
          throw new Error("Не вдалося з'єднатися з сервером");
        }
        await new Promise((res) => setTimeout(res, delay));
      } else {
        const errorMessage =
          error.response.data?.error || error.message || "Помилка запиту";
        throw new Error(errorMessage);
      }
    }
  }
};

/**
 * Уніфікована функція для виконання GET-запитів через apiClient з логікою повторних спроб.
 */
const apiGet = async (endpoint, params = {}, retries = 3, delay = 1000) => {
  for (let attempt = 0; attempt < retries; attempt++) {
    try {
      const response = await apiClient.get(endpoint, { params });
      return response.data;
    } catch (error) {
      if (!error.response) {
        console.error(
          `Помилка з'єднання ${endpoint}, спроба ${attempt + 1}:`,
          error,
        );

        if (attempt === retries - 1) {
          throw new Error("Не вдалося з'єднатися з сервером");
        }
        await new Promise((res) => setTimeout(res, delay));
      } else {
        const errorMessage =
          error.response.data?.error || error.message || "Помилка запиту";
        throw new Error(errorMessage);
      }
    }
  }
};

// --- СПИСОК ЗАПИТІВ (Тепер БЕЗ інжекта initData вручну) ---

export const getUserRegistration = async () => apiGet("/getUserRegistration");

export const getDayStreak = async () => apiGet("/getDayStreak");

export const getTopMenuData = async () => apiGet("/getTopMenuData");

export const getAiAnalysisHistory = async () => apiGet("/getAiAnalysisHistory");

export const getCurrentWeekMood = async () => apiGet("/getCurrentWeekMood");

export const postSaveMood = async (
  mood,
  additional_mood = null,
  note = null,
  follow_up = null,
  activitiesToSend = null,
) =>
  apiPost("/postSaveMood", {
    mood,
    additional_mood,
    note,
    follow_up,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC",
    activities: activitiesToSend,
  });

export const postAiPsychologist = async (message, model) =>
  apiPost("/postAiPsichologist", { message, model });

export const postAiAnalysis = async ({ model }) =>
  apiPost("/postAiAnalysis", { model, date: Date.now() });

export const getChatHistory = async (messageId = null) =>
  apiGet("/getChatHistory", messageId ? { message_id: messageId } : {});

export const getChatHistoryBefore = async (beforeMessageId, limit = 30) =>
  apiGet("/getChatHistoryBefore", {
    before_message_id: beforeMessageId,
    limit: limit,
  });

export const getCalendarMonth = async (date) =>
  apiGet("/getCalendarMonth", { date });

export const getChart = async ({ date, days }) => {
  const params = {};
  if (date) params.date = date;
  if (days) params.days = days;
  return apiGet("/getChart", params);
};

export const getAiModels = async () => apiGet("/getAiModels", {});

export const getAllMoods = async () => apiGet("/getAllMoods");

export const deleteHistory = async () => apiPost("/deleteHistory", {});

export const getProfile = async () => apiGet("/getProfile");

export const getPremium = async () => apiGet("/getPremium");

export const getAd = async () => apiGet("/getAd");

// ВИПРАВЛЕНО: Тепер дані передаються об'єктом
export const postAdClick = async (ad_id, user_id, language) =>
  apiPost("/postAdClick", { ad_id, user_id, language });

export const postCompleteGuide = async () => {
  return apiPost("/postCompleteGuide");
};

// ВИПРАВЛЕНО: Тепер мова передається об'єктом
export const postChangeAppLanguage = async (language) => {
  return apiPost("/postChangeAppLanguage", { language });
};

export const postSubscribe = async (planId) => {
  return apiPost("/postSubscribe", planId);
};

export const postDeleteChatAi = async () => {
  return apiPost("/postDeleteChatAi");
};

export const postDeleteChatFull = async () => {
  return apiPost("/postDeleteChatFull");
};

// Інструменти для AI Психолога
export const postEditMessage = async (messageId, newText) =>
  apiPost("/postEditLastMessage", {
    messageId,
    newText,
    model: localStorage.getItem("selectedAiModel") || "Basic",
  });

export const postMessageFeedback = async (messageId, feedbackType) =>
  apiPost("/postFeedback", {
    message_id: messageId,
    feedback: feedbackType,
  });

export const postRegenerateResponse = async () =>
  apiPost("/postRegenerateLastResponse", {
    model: localStorage.getItem("selectedAiModel") || "Basic",
  });

export const postDeleteMessage = async (messageId) =>
  apiPost("/postDeleteMessage", { messageId });

export const getChatHistoryAdvanced = async (
  lastMessageId = null,
  limit = 50,
) => {
  const params = { limit };
  if (lastMessageId) params.last_message_id = lastMessageId;
  return apiGet("/getChatHistoryAdvanced", params);
};

// Тести
export const getTestList = async (limit = null) => {
  const params = {};
  if (limit !== null) params.limit = limit;
  return apiGet("/getTestList", params);
};

export const getTest = async (id) => apiGet(`/getTest/${id}`);

export const postSaveTestResult = async (testId, score, answers) =>
  apiPost("/postSaveTestResult", { test_id: testId, score, answers });

// Сторіз (Історії)
export const getStoryGroups = async () => apiGet("/getStoryGroups");

export const getStoriesByGroup = async (groupId) =>
  apiGet(`/getStoriesByGroup/${groupId}`);

export const postReactToStory = async (storyId, groupId, reaction) =>
  apiPost("/postReactToStory", { storyId, groupId, reaction });

export const postVoteInStoryPoll = async (storyId, groupId, optionIds) =>
  apiPost("/postVoteInStoryPoll", { storyId, groupId, optionIds });

// Підсумки року (Year Recap)
export const getRecap = async (year = null) => {
  const params = {};
  if (year) params.year = year;
  return apiGet("/recap", params);
};

export const getRecapByYear = async (year) => apiGet(`/recap/${year}`);

export const postShareRecap = async (year = null) => {
  const data = {};
  if (year) data.year = year;
  return apiPost("/recap/share", data);
};

export const postUnshareRecap = async (year = null) => {
  const data = {};
  if (year) data.year = year;
  return apiPost("/recap/unshare", data);
};

export const getSharedRecap = async (token) =>
  apiGet(`/shared-recap/${token}`, {});

export const checkRecapAvailability = async (year = null) => {
  const params = {};
  if (year) params.year = year;
  return apiGet("/recap/check", params);
};

export const getAvailableRecapYears = async () => apiGet("/recap/years");

// Синхронізація активностей
export const postSyncUserActivities = async (allActivities) =>
  apiPost("/postSyncUserActivities", { activities: allActivities });

export const getSyncUserActivities = async () =>
  apiGet("/getSyncUserActivities");

// Практики медитацій та дихання
export const getPractices = async () => apiGet("/getPractices");
